<a *ngIf="mainJaso"
   class="page-navigation-btn return"
   (click)="onClickJasoIdx($event, null)">
  <div class="return-icon"></div>
</a>
<a *ngIf="mainJaso"
   class="page-navigation-btn {{ mainJaso === curJasoIdx ? 'on' : '' }}"
   (click)="onClickJasoIdx($event, mainJaso)">{{ mainJaso }}</a>
<a *ngFor="let jaso of jasoList"
   class="page-navigation-btn {{ jaso === curJasoIdx ? 'on' : '' }}"
   (click)="onClickJasoIdx($event, jaso)">{{ jaso[0] }}</a>
